import { throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import {EToken} from "../../model/etoken";

@Injectable()
export class TokenService {

    constructor(private http: HttpClient) { }

    obterListETokens(idUsuario: number, idOrganizacao: number): Observable<EToken[]> {
      return this.http.get<EToken[]>(environment.backendBaseUrl + `/manager/token/obterlistaetokens/${idUsuario}/${idOrganizacao}`).pipe(
        catchError((error: HttpErrorResponse | any) => {
          console.error(error.error);
          return observableThrowError(error.error);
        }));
    }

    deletaEToken(idUsuario: number, idEToken: number) : Observable<any>{
      return this.http.delete(environment.backendBaseUrl + `/manager/token/deletaetoken/${idUsuario}/${idEToken}`).pipe(
        catchError((error: HttpErrorResponse | any) => {
          console.error(JSON.stringify(error));
          return observableThrowError(error.error);
        }));
    }

    gereSenhaTemporaria(idUsuario: number, idOrganizacao: number, pinDigitado: string, nomeEToken: string, tipo: string): Observable<any> {
        let corpoRequisicao = {
            pinCertificado: pinDigitado,
            nomeEToken: nomeEToken
        };
        return this.http.post(environment.backendBaseUrl + `/manager/token/senhatemporaria/${idUsuario}/${idOrganizacao}/${tipo}`, corpoRequisicao).pipe(
            catchError((error: HttpErrorResponse | any) => {
                console.error(error.error);
                return observableThrowError(error.error);
            }));
    }

  inicializacaoETokenTerceirosFase2(token:string) : Observable<any>{
    return this.http.get(environment.backendBaseUrl + `/manager/token/inicializacaoetokenterceirosfase2/${token}`).pipe(
      catchError((error: HttpErrorResponse | any) => {
        console.error(error.error);
        return observableThrowError(error.error);
      }));
  }

    inicializacaoETokenTerceirosFase1(idUsuario: number, idOrganizacao: number, pinDigitado: string, emailTerceiro: string): Observable<any> {
      let corpoRequisicao = {
        pinCertificado: pinDigitado,
        emailTerceiro: emailTerceiro
      };
      //inicializacaoetokenterceirosfase1
      return this.http.post(environment.backendBaseUrl + `/manager/token/inicializacaoetokenterceirosfase1/${idUsuario}/${idOrganizacao}`, corpoRequisicao).pipe(
        catchError((error: HttpErrorResponse | any) => {
          console.error(error.error);
          return observableThrowError(error.error);
        }));
    }

    inicializacaoConcluida(codigoRequisicao: string, idUsuario : number, isETokenTerceiro:boolean = false): Observable<any> {
      var endpoint = "/manager/token/inicializacoconcluida";
      if(isETokenTerceiro){
        endpoint = "/manager/token/inicializaetokenterceiroscoconcluida";
      }
      return this.http.get(environment.backendBaseUrl + endpoint+`/${idUsuario}/${codigoRequisicao}`).pipe(
          catchError((error: HttpErrorResponse | any) => {
              console.error(error.error);
              return observableThrowError(error.error);
          }));
    }

    geraTokenCartao(idUsuario: number, idOrganizacao: number, requisicaoCartao: any): Observable<any> {
        return this.http.post(environment.backendBaseUrl + `/manager/token/gerartokencartao/${idUsuario}/${idOrganizacao}`, requisicaoCartao).pipe(
            catchError((error: HttpErrorResponse | any) => {
                console.error(error.message || error);
                return observableThrowError(error.error);
            }));
    }

}
